import React from 'react'
import Trans from 'next-translate/Trans'
import dynamic from 'next/dynamic'
import { useQuery } from '@apollo/client'
import styles from './styles.module.scss'

import { GET_SHORTS } from '@graphql/videos/videos.query'

const Skeleton = dynamic(() => import('@shared/components/skeleton'), { ssr: false })
const PopularVideosContent = dynamic(() => import('@shared/components/popularVideos/popularVideosContent'), {
  loading: () => loader
})

const loader =
  <>
    {Array.from(Array(3)).map((e, i) => {
      return (
        <div className='my-3 d-flex' key={i}>
          <div>
            <Skeleton height={'60px'} width={'96px '} />
          </div>
          <div className='w-100 ps-2'>
            <Skeleton height={'40px'} className={'mb-2'} />
            <div height={'14px'} className='d-flex'>
              <Skeleton width={'20%'} height={'14px'} className={'me-2'} />
              <Skeleton width={'20%'} height={'14px'} className={'me-3'} />
            </div>
          </div>
        </div>
      )
    })}

  </>

function PopularVideos() {
  const { data, loading } = useQuery(GET_SHORTS, {
    variables: { input: { nSkip: 0, nLimit: 6, bShorts: false } }
  })

  return (
    <>
      {
        data?.listVideosFront?.aResults.length !== 0 &&
        <div className='popularVideos trending-news widget'>
          <h3 className={`${styles.title} d-flex align-items-center widget-title small-head`}>
            <Trans i18nKey='common:PopularVideos' />
          </h3>
          <div className={`${styles.marginRemove} popularList`}>
            {
              !loading &&
              <PopularVideosContent data={data?.listVideosFront?.aResults} />
            }
            {
              loading && loader
            }
          </div>
        </div >
      }
    </>
  )
}

export default PopularVideos
